import Moment from 'moment';
import { concat, filter } from 'lodash';

import urls from '../constants/urls';
import { ORGANISATIONS_API_CLIENT } from '../middleware/multiClientHandler';

import { checkIfErrorCodePresent, gatherErrors } from '../utils/errorHandling';

export const LOADING_USER = 'user/LOADING_USER';
export const USER_LOAD_FAILED = 'user/USER_LOAD_FAILED';
export const USER_LOAD_SUCCESS = 'user/USER_LOAD_SUCCESS';

export const UPDATE_USER_FAILED = 'user/UPDATE_USER_FAILED';
export const UPDATE_USER_SUCCESS = 'user/UPDATE_USER_SUCCESS';
export const UPDATING_USER = 'user/UPDATING_USER';
export const USER_EMAIL_CHANGE_REQUESTED = 'user/USER_EMAIL_CHANGE_REQUESTED';

export const USER_CONFIRMATION_FAILED = 'user/CONFIRMATION_FAILED';
export const USER_CONFIRMATION_SUCCESS = 'user/CONFIRMATION_SUCCESS';
export const CONFIRMING_USER = 'user/CONFIRMING_USER';

export const HARD_DELETE_FAILED = 'user/HARD_DELETE_FAILED';
export const HARD_DELETE_SUCCESS = 'user/HARD_DELETE_SUCCESS';
export const HARD_DELETING = 'user/HARD_DELETING';

export const LOG_OUT_MOBILE_DEVICE_FAILED = 'user/LOG_OUT_MOBILE_DEVICE_FAILED';
export const LOG_OUT_MOBILE_DEVICE_SUCCESS =
  'user/LOG_OUT_MOBILE_DEVICE_SUCCESS';
export const LOG_OUT_MOBILE_DEVICE = 'user/LOG_OUT_MOBILE_DEVICE';

export const SOFT_DELETE_FAILED = 'user/SOFT_DELETE_FAILED';
export const SOFT_DELETE_SUCCESS = 'user/SOFT_DELETE_SUCCESS';
export const SOFT_DELETING = 'user/SOFT_DELETING';

export const RECOVER_USER_FAILED = 'user/RECOVER_USER_FAILED';
export const RECOVER_USER_SUCCESS = 'user/RECOVER_USER_SUCCESS';
export const RECOVERING_USER = 'user/RECOVERING_USER';

export const ADD_ADMINED_HOSPITAL_FAILED = 'user/ADD_ADMINED_HOSPITAL_FAILED';
export const ADD_ADMINED_HOSPITAL_SUCCESS = 'user/ADD_ADMINED_HOSPITAL_SUCCESS';
export const ADDING_ADMINED_HOSPITAL = 'user/ADDING_ADMINED_HOSPITAL';

export const REMOVE_ADMINED_HOSPITAL_FAILED =
  'user/REMOVE_ADMINED_HOSPITAL_FAILED';
export const REMOVE_ADMINED_HOSPITAL_SUCCESS =
  'user/REMOVE_ADMINED_HOSPITAL_SUCCESS';
export const REMOVING_ADMINED_HOSPITAL = 'user/REMOVING_ADMINED_HOSPITAL';

export const COULD_NOT_PROCESS_VERIFICATION =
  'user/COULD_NOT_PROCESS_VERIFICATION';
export const NO_PBRN_VERIFICATION_FAILED = 'user/NO_PBRN_VERIFICATION_FAILED';
export const VERIFIED_USER_PBRN_FAILED = 'user/VERIFIED_USER_PBRN_FAILED';
export const VERIFIED_USER_PBRN_SUCCESS = 'user/VERIFIED_USER_PBRN_SUCCESS';
export const VERIFYING_USER_PBRN = 'user/VERIFYING_USER_PBRN';

export const ADD_ADMINED_ORG_FAILED = 'user/ADD_ADMINED_ORG_FAILED';
export const ADD_ADMINED_ORG_SUCCESS = 'user/ADD_ADMINED_ORG_SUCCESS';
export const ADDING_ADMINED_ORG = 'user/ADDING_ADMINED_ORG';

export const REMOVE_ADMINED_ORG_FAILED = 'user/REMOVE_ADMINED_ORG_FAILED';
export const REMOVE_ADMINED_ORG_SUCCESS = 'user/REMOVE_ADMINED_ORG_SUCCESS';
export const REMOVING_ADMINED_ORG = 'user/REMOVING_ADMINED_ORG';

export const LOADING_ADMINED_ORGS_FAILED = 'user/LOADING_ADMINED_ORGS_FAILED';
export const LOADING_ADMINED_ORGS_SUCCESS = 'user/LOADING_ADMINED_ORGS_SUCCESS';
export const LOADING_ADMINED_ORGS = 'user/LOADING_ADMINED_ORGS';

const initialState = {
  adminedHospitals: [],
  adminedOrgs: [],
  favouritedHospitals: [],
  user: null,

  updateErrors: {},
  verificationErrors: {},

  failedConfirming: false,
  failedHardDeleting: false,
  failedLoading: false,
  failedSaving: false,
  failedLogOutMobileDevice: false,
  failedSoftDeleting: false,

  isConfirming: false,
  isHardDeleting: false,
  isLoading: false,
  isSaving: false,
  isLogOutMobileDevice: false,
  isSoftDeleting: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_USER:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case USER_LOAD_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        favouritedHospitals: action.payload.data.favourited_hospitals,
        adminedHospitals: action.payload.data.admined_hospitals,
        isLoading: false,
      };

    case USER_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case UPDATING_USER:
      return {
        ...state,
        updateErrors: {},
        isSaving: true,
        failedSaving: false,
      };

    case UPDATE_USER_SUCCESS:
    case USER_EMAIL_CHANGE_REQUESTED:
      return {
        ...state,
        updateErrors: {},
        user: action.payload.data,
        favouritedHospitals: action.payload.data.favourited_hospitals,
        adminedHospitals: action.payload.data.admined_hospitals,
        isSaving: false,
      };

    case UPDATE_USER_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(action.error, 'update_user_failed'),
        isSaving: false,
        failedSaving: true,
      };

    case CONFIRMING_USER:
      return {
        ...state,
        isConfirming: true,
        failedConfirming: false,
      };

    case USER_CONFIRMATION_SUCCESS:
      return {
        ...state,
        isConfirming: false,
        user: {
          ...state.user,
          confirmed_at: Moment().toString(),
        },
      };

    case USER_CONFIRMATION_FAILED:
      return {
        ...state,
        isConfirming: false,
        failedConfirming: true,
      };

    case HARD_DELETING:
      return {
        ...state,
        isHardDeleting: true,
        failedHardDeleting: false,
      };

    case HARD_DELETE_SUCCESS:
      return {
        ...state,
        isHardDeleting: false,
        user: action.payload.data,
      };

    case HARD_DELETE_FAILED:
      return {
        ...state,
        user: action.payload.data,
        isHardDeleting: false,
        failedHardDeleting: true,
      };

    case LOG_OUT_MOBILE_DEVICE:
      return {
        ...state,
        isLogOutMobileDevice: true,
        failedLogOutMobileDevice: false,
      };

    case LOG_OUT_MOBILE_DEVICE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          logged_out_at: Moment().toString(),
        },
        isLogOutMobileDevice: false,
      };

    case LOG_OUT_MOBILE_DEVICE_FAILED:
      return {
        ...state,
        isLogOutMobileDevice: false,
        failedLogOutMobileDevice: true,
      };

    case SOFT_DELETING:
      return {
        ...state,
        isSoftDeleting: true,
        failedSoftDeleting: false,
      };

    case SOFT_DELETE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          deleted: true,
        },
        isSoftDeleting: false,
      };

    case SOFT_DELETE_FAILED:
      return {
        ...state,
        isSoftDeleting: false,
        failedSoftDeleting: true,
      };

    case RECOVERING_USER:
      return {
        ...state,
        isRecovering: true,
        failedRecovering: false,
      };

    case RECOVER_USER_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          deleted: false,
        },
        isRecovering: false,
      };

    case RECOVER_USER_FAILED:
      return {
        ...state,
        isRecovering: false,
        failedRecovering: true,
      };

    case ADDING_ADMINED_HOSPITAL:
      return {
        ...state,
        addingAdminedHospital: true,
        failedAddingAdminedHospital: false,
      };

    case ADD_ADMINED_HOSPITAL_SUCCESS:
      return {
        ...state,
        addingAdminedHospital: false,
        adminedHospitals: concat(state.adminedHospitals, [action.payload.data]),
      };

    case ADD_ADMINED_HOSPITAL_FAILED:
      return {
        ...state,
        addingAdminedHospital: false,
        failedAddingAdminedHospital: true,
      };

    case REMOVING_ADMINED_HOSPITAL:
      return {
        ...state,
        removingAdminedHospital: true,
        failedremovingAdminedHospital: false,
      };

    case REMOVE_ADMINED_HOSPITAL_SUCCESS:
      let removedHospitalId = action.meta.previousAction.hospital.id;

      return {
        ...state,
        removingAdminedHospital: false,
        adminedHospitals: filter(
          state.adminedHospitals,
          hospital => hospital.id !== removedHospitalId
        ),
      };

    case REMOVE_ADMINED_HOSPITAL_FAILED:
      return {
        ...state,
        removingAdminedHospital: false,
        failedremovingAdminedHospital: true,
      };

    case VERIFYING_USER_PBRN:
      return {
        ...state,
        failedVerifyingPbrn: false,
        isVerifyingPbrn: true,
        updateErrors: {},
      };

    case VERIFIED_USER_PBRN_SUCCESS:
      return {
        ...state,
        isVerifyingPbrn: false,
        updateErrors: {},
      };

    case VERIFIED_USER_PBRN_FAILED:
      return {
        ...state,
        failedVerifyingPbrn: true,
        isVerifyingPbrn: false,
      };

    case NO_PBRN_VERIFICATION_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(action.error, 'pbrn_not_set'),
      };

    case COULD_NOT_PROCESS_VERIFICATION:
      return {
        ...state,
        updateErrors: gatherErrors(
          action.error,
          'could_not_process_verification'
        ),
      };

    case ADDING_ADMINED_ORG:
      return {
        ...state,
        addingAdminedOrg: true,
        failedAddingAdminedOrg: false,
      };

    case ADD_ADMINED_ORG_SUCCESS:
      const addedOrgId = action.meta.previousAction.orgId;

      return {
        ...state,
        addingAdminedOrg: false,
        adminedOrgs: concat(state.adminedOrgs, [
          { ...action.payload.data, id: addedOrgId },
        ]),
      };

    case ADD_ADMINED_ORG_FAILED:
      return {
        ...state,
        addingAdminedOrg: false,
        failedAddingAdminedOrg: true,
      };

    case REMOVING_ADMINED_ORG:
      return {
        ...state,
        removingAdminedOrg: true,
        failedremovingAdminedOrg: false,
      };

    case REMOVE_ADMINED_ORG_SUCCESS:
      const removedOrgId = action.meta.previousAction.orgId;

      return {
        ...state,
        removingAdminedOrg: false,
        adminedOrgs: filter(state.adminedOrgs, org => org.id !== removedOrgId),
      };

    case REMOVE_ADMINED_ORG_FAILED:
      return {
        ...state,
        removingAdminedOrg: false,
        failedremovingAdminedOrg: true,
      };

    case LOADING_ADMINED_ORGS_SUCCESS:
      return {
        ...state,
        adminedOrgs: action.payload.data.data,
      };

    default:
      return state;
  }
};

export const loadUser = userId => dispatch => {
  return dispatch({
    types: [LOADING_USER, USER_LOAD_SUCCESS, USER_LOAD_FAILED],
    payload: {
      request: {
        url: urls.users.show(userId),
      },
    },
  });
};

export const updateUser = (userId, params) => dispatch => {
  const userParams = {
    banned_from_messaging: params.banned_from_messaging,
    current_password: params.current_password,
    email: params.email,
    email_approved_for_messaging: params.email_approved_for_messaging,
    first_name: params.first_name,
    last_name: params.last_name,
    new_email: params.new_email,
    password: params.password,
    password_confirmation: params.password_confirmation,
    pbrn_type: params.pbrn_type,
    professional_body_registration_number:
      params.professional_body_registration_number,
    rank: params.rank,
    role: params.role,
    grade: params.grade,
    searchable: params.searchable,
    validate_role_and_grade_presence: true,
  };

  let successType = params.new_email
    ? USER_EMAIL_CHANGE_REQUESTED
    : UPDATE_USER_SUCCESS;

  return dispatch({
    types: [UPDATING_USER, successType, UPDATE_USER_FAILED],
    payload: {
      request: {
        method: 'patch',
        url: urls.users.update(userId),
        data: { user: userParams },
      },
    },
  });
};

export const verifyUserPbrn = (userId, approve) => dispatch => {
  let approvalParam = approve ? 'true' : 'false';

  let onError = ({ error }) => {
    if (checkIfErrorCodePresent(error, 'pbrn_not_set')) {
      dispatch({
        type: NO_PBRN_VERIFICATION_FAILED,
        error,
      });
    } else if (
      checkIfErrorCodePresent(error, 'could_not_process_verification')
    ) {
      dispatch({
        type: COULD_NOT_PROCESS_VERIFICATION,
        error,
      });
    }
  };

  let action = {
    types: [
      VERIFYING_USER_PBRN,
      VERIFIED_USER_PBRN_SUCCESS,
      VERIFIED_USER_PBRN_FAILED,
    ],
    payload: {
      request: {
        method: 'patch',
        url: urls.users.pbrnVerification.update(userId),
        data: {
          professional_body_registration_number: {
            approve: approvalParam,
          },
        },
      },
    },
  };

  let promise = dispatch(action);

  promise.catch(onError);

  return promise;
};

export const confirm = userId => dispatch => {
  return dispatch({
    types: [
      CONFIRMING_USER,
      USER_CONFIRMATION_SUCCESS,
      USER_CONFIRMATION_FAILED,
    ],
    payload: {
      request: {
        method: 'patch',
        url: urls.users.confirm(userId),
      },
    },
  });
};

export const recoverFromSoftDelete = userId => dispatch => {
  return dispatch({
    types: [RECOVERING_USER, RECOVER_USER_SUCCESS, RECOVER_USER_FAILED],
    payload: {
      request: {
        method: 'delete',
        url: urls.users.recover(userId),
      },
    },
  });
};

export const hardDelete = userId => dispatch => {
  return dispatch({
    types: [HARD_DELETING, HARD_DELETE_SUCCESS, HARD_DELETE_FAILED],
    payload: {
      request: {
        method: 'post',
        url: urls.users.hardDelete(userId),
      },
    },
  });
};

export const logoutEverywhere = userId => dispatch => {
  return dispatch({
    types: [
      LOG_OUT_MOBILE_DEVICE,
      LOG_OUT_MOBILE_DEVICE_SUCCESS,
      LOG_OUT_MOBILE_DEVICE_FAILED,
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.users.logoutEverywhere(userId),
      },
    },
  });
};

export const softDelete = userId => dispatch => {
  return dispatch({
    types: [SOFT_DELETING, SOFT_DELETE_SUCCESS, SOFT_DELETE_FAILED],
    payload: {
      request: {
        method: 'delete',
        url: urls.users.softDelete(userId),
      },
    },
  });
};

export const createAdminHospital = (user, hospital) => dispatch => {
  return dispatch({
    types: [
      ADDING_ADMINED_HOSPITAL,
      ADD_ADMINED_HOSPITAL_SUCCESS,
      ADD_ADMINED_HOSPITAL_FAILED,
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.users.hospitals.admined.create(user.id, hospital.id),
      },
    },
  });
};

export const deleteAdminHospital = (user, hospital) => dispatch => {
  return dispatch({
    types: [
      REMOVING_ADMINED_HOSPITAL,
      REMOVE_ADMINED_HOSPITAL_SUCCESS,
      REMOVE_ADMINED_HOSPITAL_FAILED,
    ],
    payload: {
      request: {
        method: 'delete',
        url: urls.users.hospitals.admined.destroy(user.id, hospital.id),
      },
    },
    hospital: hospital,
  });
};

export const createAdminOrg = (userId, orgId) => dispatch => {
  return dispatch({
    types: [
      ADDING_ADMINED_ORG,
      ADD_ADMINED_ORG_SUCCESS,
      ADD_ADMINED_ORG_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        method: 'post',
        url: urls.users.organisations.admined.create(userId, orgId),
      },
    },
    orgId: orgId,
  });
};

export const deleteAdminOrg = (userId, orgId) => dispatch => {
  return dispatch({
    types: [
      REMOVING_ADMINED_ORG,
      REMOVE_ADMINED_ORG_SUCCESS,
      REMOVE_ADMINED_ORG_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        method: 'delete',
        url: urls.users.organisations.admined.destroy(userId, orgId),
      },
    },
    orgId: orgId,
  });
};

export const loadAdminedOrgs = userId => dispatch => {
  return dispatch({
    types: [
      LOADING_ADMINED_ORGS,
      LOADING_ADMINED_ORGS_SUCCESS,
      LOADING_ADMINED_ORGS_SUCCESS,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        method: 'get',
        url: urls.users.organisations.admined.show(userId),
      },
    },
  });
};
